import useScrollReveal from "./shared/useScrollReveal";

 import vmLogoPlaceholder from "../../Assets/levdc/vmlogoplaceholder.png";
 import comptabilityimg from "../../Assets/levdc/compatibility.png";

// 6 placeholder OEM logo slots (4 for 2-wheeler OEMs, 2 for 3-wheeler) —
// swap vmLogoPlaceholder for each real OEM logo when you have them.
import logo1 from "../../Assets/levdc/clientlogo1.png";
import logo2 from "../../Assets/levdc/clientlogo7.png";
import logo3 from "../../Assets/levdc/clientlogo3.png";
import logo4 from "../../Assets/levdc/clientlogo4.png";
import logo5 from "../../Assets/levdc/clientlogo5.png";
import logo6 from "../../Assets/levdc/clientlogo8.png";

const OEM_LOGOS = [
  { alt: "2W OEM Placeholder", src: logo1 },
  { alt: "2W OEM Placeholder", src: logo2 },
  { alt: "2W OEM Placeholder", src: logo3 },
  { alt: "2W OEM Placeholder", src: logo4 },
  { alt: "3W OEM Placeholder", src: logo5 },
  { alt: "3W OEM Placeholder", src: logo6 },
];

export default function Compatibility() {
  const ref = useScrollReveal();

  return (
    <section className="compat" id="compatibility" ref={ref}>
      <div className="containers-min mx-auto px-4 py-12">
        <div className="compat-grid">
          <div className="compat-left">
            <p className="section-label reveal">Vehicle Compatibility</p>
            <h2 className="section-title reveal font-gilroy h3">Designed for India’s 2W &amp; 3W EV Era</h2>
            <p className="compat-desc reveal text-xl">
               LEV DC is built around India’s Type 6 charging standard for light electric vehicles, enabling convenient DC charging for compatible electric two-wheelers and three-wheelers across a growing range of OEMs.
            </p>
            <p className="compat-desc reveal text-xl">From daily commuting to last-mile delivery and high-utilization fleets, LEV DC is engineered to support the evolving needs of India’s electric mobility ecosystem.</p>
            <div className="compat-logos reveal">
              {OEM_LOGOS.map((logo, i) => (
                <div className="compat-logo" key={i}>
                  <img src={logo.src} alt={logo.alt} />
                </div>
              ))}
            </div>
          </div>

          <div className="compat-right reveal">
            <div className="compat-img">
              <img
                // src="https://picsum.photos/seed/levdc-compat/900/1125"
                src={comptabilityimg}
                alt="LEV DC charger with compatible two- and three-wheeler EVs"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
